import React from 'react';
import Button from '@material-ui/core/Button';
import {ButtonProps, withStyles} from '@material-ui/core';

const UpdateButton = withStyles<string, undefined, ButtonProps>(theme => ({
    root: {
        position: 'relative',
        zIndex: 100,

        minHeight: '0px',
        height: '53px',
        minWidth: 'max-content',

        color: theme.palette.background.overlays,
        backgroundColor: 'rgba(255, 255, 255, 0.72)',

        margin: theme.spacing(0, 2),

        '&> span': {
            whiteSpace: 'nowrap'
        },

        '&:hover': {
            backgroundColor: theme.palette.common.white
        }
    }
}))(props => <Button {...props} component="div" />);

export default UpdateButton;
